import { render, staticRenderFns } from "./rate-warning.vue?vue&type=template&id=2f16ebc4&lang=pug&"
import script from "./rate-warning.vue?vue&type=script&lang=js&"
export * from "./rate-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports